/*
 * Copyright 2026 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import sync from "./sync/index.js";
const command = {
  command: "branch",
  describe: "Interact with branched SDKs published on a global branch",
  builder: argv => {
    return argv.options({
      branchName: {
        type: "string",
        description: "Git branch name used to select the branched SDKs (defaults to the current git branch)."
      }
    }).command(sync).demandCommand();
  },
  handler: async () => {}
};
export default command;